<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/manage-assessments']"><img
            src="assets/images/admin/backarrow.png" /> Back To Manage Assessments</a>

    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap mt-4 pt-2">
    <div class="adminInnerHead pt-2">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="userCouresLatest pb-2">
                    <div class="userCouresContent">
                        <h3>{{assessmentDetails?.assessment_name}}</h3>
                        <p>
                            <span>Created by: {{assessmentDetails?.created_by}} on
                                {{assessmentDetails?.created_dttm | date:'d MMM, y'}}</span>
                        </p>
                      
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="courseTabs">
                    <p>{{assessmentDetails?.course_desc}}</p>
                    <ul class="customTab">
                        <li><a href="javascript:void(0);" [routerLink]="['/view-assessment']"
                                [queryParams]="{id:assessment_id,tab:tab}" class="active">VIEW</a> </li>

                        <!-- <li><a href="javascript:void(0);" [routerLink]="['/courses_view_user']"
                                [queryParams]="{id:assessment_id,tab:tab}">VIEW USERS</a> </li> -->
                        <li *ngIf="assessmentDetails.is_active==1"><a href="javascript:void(0);"
                                [routerLink]="['/view-user']"
                                [queryParams]="{id:assessment_id,tab:tab}">ASSIGNED TO
                                (USERS)</a> </li>
                        <li *ngIf="assessmentDetails.is_active==1"><a href="javascript:void(0);"
                                [routerLink]="['/assign-users']"
                                [queryParams]="{id:assessment_id,tab:tab}">ASSIGN USERS</a> </li>
                        <li *ngIf="assessmentDetails.assigned_users==0"><a href="javascript:void(0);" [routerLink]="['/create-assessment']"
                                [queryParams]="{assId:assessment_id,tab:tab}" >EDIT</a> </li>
                        <li><a href="javascript:void(0);" (click)="open(duplicate)">DUPLICATE</a> </li>
                        <li class="deactiveTab" *ngIf="assessmentDetails.is_active==1"><a href="javascript:void(0);"
                                (click)="open(deactivate)">DEACTIVATE</a> </li>
                        <li class="deactiveTab" *ngIf="assessmentDetails.is_active==0"><a href="javascript:void(0);"
                                (click)="open(activate)">ACTIVATE</a> </li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
</div>
<div class="formHeading pr-0">
    <div class="row m-0">
        <div class="col-12 col-md-6">
            <h2>View Assessment</h2>
            <p [innerHtml]='capsuleName'>{{capsuleName}}}</p>
        </div>
    </div>
</div>
<div class="sttperWrap pt-1 mb-4">
    <div class="sttperBody sttperContentBody mt-2">
        <div class="row m-0">
            <h4>INSTRUCTIONS</h4>
            <div class="detailViewer justify-content-end mt-0 mb-3 ml-auto">
                <div class="joinerDetails">
                    <span class="joinerDetailsImage"><img src="assets/images/icons/questionMark.png"></span>
                    <div class="joinerContent">
                        <h3>{{assessmentDetails.total_questions}}</h3>
                        <p>No. of Questions</p>
                    </div>
                </div>
                <div class="joinerDetails">
                    <span class="joinerDetailsImage"><img src="assets/images/icons/time.svg"></span>
                    <div class="joinerContent">
                        <h3>{{assessmentDetails.assest_time_hr}} hr {{assessmentDetails.assest_time_min}} min</h3>
                        <p>Time limit for assessment</p>
                    </div>
                </div>
            </div>
        </div>
        <p [innerHtml]='assessmentDetails.assessment_instruction'></p>
        <div claas="passingarea d-flex pt-3">
            <b>passing Criteria:</b>
            <div class="passingResult d-inline-flex">&nbsp;<span class="pr-4 mr-4 border-right">Internal
                    Organisation<small>-{{assessmentDetails.internal_org_pass_no_of_questions}} Correct
                        Answer</small></span><span>External
                    Organisation<small>-{{assessmentDetails.external_org_pass_no_of_questions}} Correct
                        Answer</small></span></div>

        </div>
        <div class="questionWrapView">
            <div class="questionWrap" *ngFor="let assQuestion of assessmentDetails.questions;let ind=index;">
                <div class="questionListWrap" *ngIf="assQuestion.question_type ==2">
                    <h2>Question {{assQuestion.question_num}} <span>[{{assQuestion.question_num}} out of
                            {{assessmentDetails.total_questions}}]</span></h2>
                    <h3>{{assQuestion.question_text}}</h3>
                    <div class="viewUploadWrap" *ngIf="assQuestion.question_asset_url">
                        <div class="viewUpload">
                            <figure>
                                <img [src]="assQuestion.question_asset_url" />
                            </figure>
                            <div class="blueUploadWrap">
                                <b class="name"></b>
                            </div>
                        </div>
                    </div>
                    <ul class="ausWrap">
                        <li>
                            <div class="questionUi">
                                <input type="text" name="question01" readonly>
                                <b>A</b>
                                <span>True</span>
                            </div>
                        </li>
                        <li>
                            <div class="questionUi">
                                <input type="text" name="question01" readonly>
                                <b>B</b>
                                <span>False</span>
                            </div>
                        </li>
                    </ul>
                    <div class="rightAns">Right Answer: <b>Option {{assQuestion.correct_response_no}}</b></div>
                </div>
                <div class="questionListWrap" *ngIf="assQuestion.question_type == 1">
                    <h2>Question {{assQuestion.question_num}} <span>[{{assQuestion.question_num}} out of
                            {{assessmentDetails.total_questions}}]</span></h2>
                    <h3>{{assQuestion.question_text}}</h3>
                    <div class="viewUploadWrap" *ngIf="assQuestion.question_asset_url">
                        <div class="viewUpload">
                            <figure>
                                <img [src]="assQuestion.question_asset_url" />
                            </figure>
                            <div class="blueUploadWrap">
                                <b class="name"></b>
                            </div>
                        </div>
                    </div>
                    <ul class="ausWrap" *ngFor="let responsesOp of assQuestion.responses;let j=index;">
                        <li *ngIf="responsesOp.response != null">
                            <div class="questionUi">
                                <input type="text" name="question01" readonly>
                                <b>{{j+1}}</b>
                                <span>{{responsesOp.response}}</span>
                            </div>
                        </li>
                    </ul>
                    <div class="rightAns">Right Answer: <b>Option {{assQuestion.correct_response_no}}</b></div>
                </div>
                <div class="questionListWrap" *ngIf="assQuestion.question_type == 3">
                    <h2>Question {{assQuestion.question_num}} <span>[{{assQuestion.question_num}} out of
                            {{assessmentDetails.total_questions}}]</span></h2>
                    <h3>{{assQuestion.question_text}}</h3>
                    <div class="viewUploadWrap" *ngIf="assQuestion.question_asset_url">
                        <div class="viewUpload">
                            <figure>
                                <img [src]="assQuestion.question_asset_url" />
                            </figure>
                            <div class="blueUploadWrap">
                                <b class="name"></b>
                            </div>
                        </div>
                    </div>
                    <ul class="ausWrap matchOption" *ngFor="let responsesOp of assQuestion.responses;let j=index;">
                        <li *ngIf="responsesOp.response != null && responsesOp.response != ''">
                            <div class="questionUi">
                                <input type="text" name="question01" readonly>
                                <b>{{j+1}}</b>
                                <span>{{responsesOp.response}}</span>

                            </div>
                            <div class="questionUi">
                                <input type="text" name="question01" readonly>
                                <span>{{responsesOp.response_match}}</span>

                            </div>
                        </li>
                    </ul>
                    <!-- <div class="rightAns">Right Answer: <b>Option {{assQuestion.correct_response_no}}</b></div> -->
                </div>

            </div>

        </div>
    </div>
    <div class="sttperFooter">
    </div>
</div>
<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<ng-template #activate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Activate assessment</h6>
                <p class="size18">Are you sure you want to activate this assessment?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="changeIsDeActiveVal(1)">Yes,
                    Activate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #deactivate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>DeActivate course</h6>
                <p class="size18">Are you sure you want to deactivate this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="changeIsDeActiveVal(0)">Yes,
                    DeActivate</a>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #duplicate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Duplicate assessment</h6>
                <p class="size18">Are you sure you want to duplicate this assessment?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="duplicateAssessment()">Yes,
                    Duplicate</a>
            </div>
        </div>
    </div>
</ng-template>